import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Router, RouterOutlet } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-admin-navigation',
  standalone: true,
  imports: [
    MenubarModule,
    RouterOutlet
],
  templateUrl: './admin-navigation.html',
  styleUrl: './admin-navigation.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminNavigationComponent implements OnInit {
  menuItems: MenuItem[] = [];

  constructor(private router: Router) {}

  ngOnInit() {
    this.menuItems = [
      {
        label: 'Models',
        icon: 'pi pi-database',
        routerLink: ['/admin/models']
      },
      {
        label: $localize`:@@nav.admin.benchmarks:Benchmarks`,
        icon: 'pi pi-chart-bar',
        routerLink: ['/admin/benchmarks']
      },
      {
        label: 'Language-Locales',
        icon: 'pi pi-globe',
        routerLink: ['/admin/language-locales']
      },
      {
        label: 'Plans',
        icon: 'pi pi-credit-card',
        routerLink: ['/admin/plans']
      },
      {
        label: 'Users',
        icon: 'pi pi-users',
        routerLink: ['/admin/users']
      },
      {
        label: $localize`:@@nav.admin.settings:System settings`,
        icon: 'pi pi-cog',
        routerLink: ['/admin/settings']
      },
      {
        label: $localize`:@@nav.admin.livekit:LiveKit`,
        icon: 'pi pi-server',
        routerLink: ['/admin/livekit']
      }
    ];
  }
}
